/**
 * Завантаження pdf.js (`pdfjs-dist`, рішення D-14) — лише коли відкривають
 * PDF: бібліотека з воркером важить ~2 МБ, і в основний бандл їй не місце.
 *
 * Збірка — `legacy`: сучасна (`build/`) кличе `Map.prototype.getOrInsertComputed`
 * і `Math.sumPrecise` без поліфілів, а їх немає в браузерах, старших за
 * 2026 рік, — PDF просто не відкрився б. `legacy` несе поліфіли й важить
 * лише на ~60 КБ більше.
 *
 * Воркер — як радить документація pdf.js для Vite: файл воркера з пакета
 * імпортується з суфіксом `?url`, Vite копіює його в збірку окремим ресурсом
 * і віддає адресу, яку ставимо в `GlobalWorkerOptions.workerSrc`.
 */

type PdfJs = typeof import('pdfjs-dist/legacy/build/pdf.mjs')

let loading: Promise<PdfJs> | null = null

export const loadPdfJs = (): Promise<PdfJs> => {
    if (loading === null) {
        loading = Promise.all([
            import('pdfjs-dist/legacy/build/pdf.mjs'),
            import('pdfjs-dist/legacy/build/pdf.worker.min.mjs?url'),
        ]).then(
            ([pdfjs, worker]) => {
                pdfjs.GlobalWorkerOptions.workerSrc = worker.default

                return pdfjs
            },
            (error: unknown) => {
                // Не вдалося підвантажити модуль (обрив зв'язку) — наступна спроба почне знову
                loading = null
                throw error
            }
        )
    }

    return loading
}
